import React, {Component, Fragment} from 'react';
import './App.css';
import HordeScores from "./HordeScores";
import {parse} from "date-fns";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      matches: null,
      error: null
    }
  }

  matchesLoaded(matches) {
    matches.sort((lhs, rhs) => {
      if (lhs.wave === rhs.wave) {
        return rhs.score - lhs.score;
      }
      return rhs.wave - lhs.wave;
    });

    const best = matches.slice(0, Math.min(10, matches.length));

    const adapted = best.map(match => {
      return {
        ...match,
        start: parse(match.start),
        end: parse(match.end),
      }
    });

    this.setState({matches: adapted, error: null});
  }

  componentDidMount() {
    fetch("/api/horde/matches").then(response => {
      return response.json();
    }).then(json => {
      this.matchesLoaded(json.matches);
    }).catch(error => {
      this.setState({error: error.message})
    });
  }

  render() {
    return (
      <Fragment>
        <div className="Content">
          <HordeScores matches={this.state.matches} error={this.state.error}/>
        </div>
      </Fragment>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js